/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import Text from 'src/components/ts-components/Text'
import TeamLogo from './TeamLogo'

interface Props {
  team: { name: string; image?: unknown }
}

/**
 * What the closed select shows for a chosen team: logo + name. The option's
 * full history row is too tall for the 50px control.
 */
const TeamSelectedLabel = ({ team }: Props) => (
  <span css={labelStyle}>
    <TeamLogo team={team} size={24} />
    <Text variant='paragraphSmall' weight='regular' color={colors.WHITE}>
      {team.name}
    </Text>
  </span>
)

export default TeamSelectedLabel

const labelStyle = css`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`
